/* @flow weak */

'use strict';

const React = require('react');
const Reflux = require('reflux');
const _ = require('lodash');

// Initializing all the stores
const AnswerStore = require('../stores/AnswerStore.jsx');
const PartStore = require('../stores/PartStore.jsx');
const ProductStore = require('../stores/ProductStore.jsx');
const QuestionStore = require('../stores/QuestionStore.jsx');
const UCStore = require('../stores/UCStore.jsx');

// Then the actions we need
const UCActions = require('../actions/UCActions.jsx');

// Grab the master UI sections
const MainSection = require('./section/MainSection.jsx');
const DetailSection = require('./section/DetailSection.jsx');
const DialogRenderer = require('./renderers/DialogRenderer.jsx');

const Config = require('../configs/Config.js');
const { authKey, productId, configId, schoolCode, channel, ppFlag, ppFlagActive, ln } = require('../loaders');

// Finally require all controls
require.context('./controls');

const App = React.createClass({
  mixins: [Reflux.connect(UCStore, 'data')],

  componentWillMount() {
    if (!authKey) {
      throw new Error('No authorization key provided');
    }

    if (!productId) {
      throw new Error('No product ID specified');
    }

    if (_.get(Config, 'schoolCodeRequired') === true && !schoolCode) {
      throw new Error('No school code specified');
    }

    UCActions.setPaymentPlanFlag(ppFlag);
    UCActions.setPaymentPlanFlagActive(ppFlagActive);

    if (configId) {
      return UCActions.loadConfig(configId, productId, schoolCode, channel, authKey, this.showErrorDialog, ln);
    }

    return UCActions.loadProduct(productId, schoolCode, channel, authKey, this.showErrorDialog, ln);
  },

  shouldComponentUpdate(nextProps, nextState) {
    return (this.state.data.loaded !== nextState.data.loaded);
  },

  showErrorDialog(message, html) {
    this.errorDialog.showDialog(null, null, null, message, html);
  },

  renderLoadingSpinner() {
    return (
      <div className='uc-loading-message'>
        Loading...
      </div>
    );
  },

  renderConfigurator() {
    return (
      <div>
        <MainSection />

        {Config.features.productDetailsPosition === 'bottom' ?
          <DetailSection productData={this.state.data.product} />
          : null}
      </div>
    );
  },

  render() {
    let wrapperClass = 'uc-root';
    if (!!Config.features.wrapperExtraClass) {
      wrapperClass += ' ' + Config.features.wrapperExtraClass;
    }

    return (
      <div className={wrapperClass}>
        {this.state.data.loaded ? this.renderConfigurator() : this.renderLoadingSpinner()}

        <DialogRenderer
          ref={(c) => this.errorDialog = c}
          title='<h1>Warning</h1>'
          buttons={[{ text: 'OK', btnClass: 'uc-primary-btn' }]}
        />
      </div>
    );
  }
});

module.exports = App;



// WEBPACK FOOTER //
// ./src/base/scripts/components/app.jsx